import { defineStore } from 'pinia'
import axios from '@axios'

const CURRENT_VERSION = '1.0-beta'

export const useAiConsentStore = defineStore({
  id: 'aiConsent',
  state: () => ({
    consented: false,
    userVersion: null,
    agreedAt: null,
    checked: false,
    showModal: false,
    _resolve: null,
    _reject: null,
  }),
  getters: {
    hasValidConsent(state) {
      return state.consented && state.userVersion === CURRENT_VERSION
    },
    currentVersion() {
      return CURRENT_VERSION
    },
  },
  actions: {
    setFromApi(data) {
      this.consented = data.consented
      this.userVersion = data.user_version
      this.agreedAt = data.agreed_at
      this.checked = true
    },
    async checkStatus() {
      // Auto-consent in development mode to allow mock testing
      if (process.env.VUE_APP_ENVIRONMENT === 'development') {
        this.consented = true
        this.userVersion = CURRENT_VERSION
        this.checked = true
        return
      }
      try {
        const res = await axios.get('/ai/consent/status')
        this.setFromApi(res.data)
      } catch (e) {
        this.checked = true
      }
    },
    requestConsent() {
      // If modal already open, reuse the same pending promise instead of overwriting
      if (this.showModal && this._resolve) {
        return new Promise((resolve, reject) => {
          const prevResolve = this._resolve
          const prevReject = this._reject
          this._resolve = (v) => { prevResolve(v); resolve(v) }
          this._reject = (e) => { prevReject(e); reject(e) }
        })
      }
      this.showModal = true
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this._reject = reject
      })
    },
    async submitConsent() {
      const res = await axios.post('/ai/consent', { version: CURRENT_VERSION })
      this.consented = true
      this.userVersion = CURRENT_VERSION
      this.agreedAt = res.data.agreed_at
      this.checked = true
      this.showModal = false
      if (this._resolve) {
        this._resolve()
        this._resolve = null
        this._reject = null
      }
    },
    dismissConsent() {
      this.showModal = false
      if (this._reject) {
        this._reject(new Error('consent_dismissed'))
        this._resolve = null
        this._reject = null
      }
    },
  },
})
